export default __webpack_public_path__ + "static/media/projectoC.25a29c4a.png";